import { checkNull2String, getOnlyDate } from "./ItemTools"
import { RespResumeOtherDataAttachmentList, RespResumeOtherAttachment } from "./ItemResume"


export class ReqCustomerContractList {
    constructor({ companyId, start, limit, companyName, workAddress, contractStatus, jobName, jobType, contractMaturity }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        this.companyName = companyName
        this.workAddress = workAddress
        this.contractStatus = contractStatus
        this.jobName = jobName
        this.jobType = jobType
        this.contractMaturity = contractMaturity
    }

    fromJson(jsonData) {
        if (this.companyId === undefined)
            this.companyId = jsonData.companyId
        this.companyName = jsonData.companyName||""
        this.workAddress = jsonData.workAddress||""
        this.contractStatus = jsonData.contractStatus||""
        this.jobName = jsonData.jobName||""
        this.jobType = jsonData.jobType||""
        this.contractMaturity = jsonData.contractMaturity||""
    }
}

export class ReqCustomerContractDetail {
    constructor({ companyId, customerContractId }) {
        this.companyId = companyId
        this.customerContractId = customerContractId
    }
}

export class RespCustomerContract {
    constructor({ customerContractId, companyId, info, isDisable = 0, isPublic = 1, signAt, startAt, endAt, creatAccountId, creatAt }) {
        this.companyId = companyId
        this.customerContractId = customerContractId
        this.info = info
        this.isDisable = isDisable
        this.isPublic = isPublic
        this.signAt = signAt
        this.startAt = startAt
        this.endAt = endAt
        if (creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if (creatAt !== undefined)
            this.creatAt = creatAt
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)
        this.customerContractId = jsonData.customerContractId
        this.companyId = jsonData.companyId
        this.info = new RespCustomerContractInfo({})
        this.info.fromJson(jsonData.info)
        this.isDisable = jsonData.isDisable
        this.isPublic = jsonData.isPublic
        this.signAt = jsonData.signAt
        this.startAt = jsonData.startAt
        this.endAt = jsonData.endAt
        this.creatAccountId = jsonData.creatAccountId
        this.creatAt = jsonData.creatAt
    }
}
export class RespCustomerContractInfo {
    constructor({
        customerInformation,        //事業單位資訊
        personnelContact,           //人事聯絡窗口
        attendanceSalaryContact,    //出勤薪資聯絡窗口
        paymentTerms,               //付款條件
        jobNote,                    //轉正服務事項
        note,                       //備註
        AProjectContact,            //甲方專案聯絡人
        BProjectContact,            //乙方專案聯絡人
        companyInContact,           //代表乙方簽約之公司
        attachment,                 //附件
    }) {
        this.customerInformation = customerInformation
        this.personnelContact = personnelContact
        this.attendanceSalaryContact = attendanceSalaryContact
        this.paymentTerms = paymentTerms
        this.jobNote = jobNote
        this.note = note
        this.AProjectContact = AProjectContact
        this.BProjectContact = BProjectContact
        this.companyInContact = companyInContact
        this.attachment = attachment
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.customerInformation = new RespCustomerContract_CustomerInformation({})
        this.customerInformation.fromJson(jsonData.customerInformation)

        this.personnelContact = new RespCustomerContract_Contact({})
        this.personnelContact.fromJson(jsonData.personnelContact)

        this.attendanceSalaryContact = new RespCustomerContract_Contact({})
        this.attendanceSalaryContact.fromJson(jsonData.attendanceSalaryContact)

        this.paymentTerms = new RespCustomerContract_PaymentTerms({})
        this.paymentTerms.fromJson(jsonData.paymentTerms)
        this.jobNote = checkNull2String(jsonData.jobNote)
        this.note = checkNull2String(jsonData.note)
        this.AProjectContact = new RespCustomerContract_ProjectContact({})
        this.AProjectContact.fromJson(jsonData.AProjectContact)
        this.BProjectContact = new RespCustomerContract_ProjectContact({})
        this.BProjectContact.fromJson(jsonData.BProjectContact)
        this.companyInContact = new RespCustomerContract_CompanyInContact({})
        this.companyInContact.fromJson(jsonData.companyInContact)

        this.attachment = []
        //console.log(JSON.stringify(jsonData.attachment))
        for (var key in jsonData.attachment) {
            //console.log(key)
            this.attachment[key] = new RespResumeOtherAttachment(jsonData.attachment[key])
        }
    }
}

export class RespCustomerContract_CustomerInformation {
    /**
     * 事業單位資訊
     * @constructor
     * @param {string} companyName 公司名稱
     * @param {string} texIdNumber 公司統編
     * @param {string} companyAddress 公司地址
     */
    constructor({ companyName = "", texIdNumber = "", companyAddress = "" }) {
        this.companyName = companyName
        this.texIdNumber = texIdNumber
        this.companyAddress = companyAddress
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.companyName = checkNull2String(jsonData.companyName)
        this.texIdNumber = checkNull2String(jsonData.texIdNumber)
        this.companyAddress = checkNull2String(jsonData.companyAddress)
    }
}

export class RespCustomerContract_Contact {
    /**
     * 人事聯絡窗口 || 出勤薪資聯絡窗口
     * @constructor
     * @param {string} unitTitle 單位職稱
     * @param {string} name 姓名
     * @param {string} email 電子郵件
     * @param {string} tel 電話
     * @param {string} fax 傳真
     */
    constructor({ unitTitle = "", name = "", email = "", tel = "", fax = "" }) {
        this.unitTitle = unitTitle
        this.name = name
        this.email = email
        this.tel = tel
        this.fax = fax
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.unitTitle = checkNull2String(jsonData.unitTitle)
        this.name = checkNull2String(jsonData.name)
        this.email = checkNull2String(jsonData.email)
        this.tel = checkNull2String(jsonData.tel)
        this.fax = checkNull2String(jsonData.fax)
    }
}

export class RespCustomerContract_PaymentTerms {
    /**
     * 專案聯絡人
     * @constructor
     * @param {string} paymentDate1 每月 之前核定請款檔
     * @param {string} paymentDate2 每月 之前雙方確認無誤並由乙方開立發票
     * @param {string} paymentDate3 甲方於每月 之前匯款
     * @param {string} paymentAnnualLeave 廠商是否支付特休給付
     * @param {string} paymentCycleDateStart 請款結算週期開始於每月
     * @param {string} paymentCycleDateEnd 請款結算週期結束於每月
     * @param {string} paymentMethod 付款方式
     * @param {string} paymentTax 報價是否含5%營業稅
     */
    constructor({ paymentDate1 = "", paymentDate2 = "", paymentDate3 = "", paymentAnnualLeave = ""
        , paymentCycleDateStart = "", paymentCycleDateEnd = "", paymentMethod = "", paymentTax = "" }) {
        this.paymentDate1 = paymentDate1
        this.paymentDate2 = paymentDate2
        this.paymentDate3 = paymentDate3
        this.paymentAnnualLeave = paymentAnnualLeave
        this.paymentCycleDateStart = paymentCycleDateStart
        this.paymentCycleDateEnd = paymentCycleDateEnd
        this.paymentMethod = paymentMethod
        this.paymentTax = paymentTax
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        // console.log(jsonData)
        this.paymentDate1 = checkNull2String(jsonData.paymentDate1)
        this.paymentDate2 = checkNull2String(jsonData.paymentDate2)
        this.paymentDate3 = checkNull2String(jsonData.paymentDate3)
        this.paymentAnnualLeave = checkNull2String(jsonData.paymentAnnualLeave)
        this.paymentCycleDateStart = checkNull2String(jsonData.paymentCycleDateStart)
        this.paymentCycleDateEnd = checkNull2String(jsonData.paymentCycleDateEnd)
        this.paymentMethod = checkNull2String(jsonData.paymentMethod)
        this.paymentTax = checkNull2String(jsonData.paymentTax)
    }
}

export class RespCustomerContract_ProjectContact {
    /**
     * 專案聯絡人
     * @constructor
     * @param {string} department 部門
     * @param {string} jobTitle 職稱
     * @param {string} name 姓名
     * @param {string} tel 電話
     */
    constructor({ department = "", jobTitle = "", name = "", tel = "" }) {
        this.department = department
        this.jobTitle = jobTitle
        this.name = name
        this.tel = tel
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.department = checkNull2String(jsonData.department)
        this.jobTitle = checkNull2String(jsonData.jobTitle)
        this.name = checkNull2String(jsonData.name)
        this.tel = checkNull2String(jsonData.tel)
    }
}

export class RespCustomerContract_CompanyInContact {
    /**
     * 代表乙方簽約之公司
     * @constructor
     * @param {string} companyNameInContact 簽約公司名稱
     * @param {string} companyNameInContactGUI 統編
     */
    constructor({ companyNameInContact = "", companyNameInContactGUI = "" }) {
        this.companyNameInContact = companyNameInContact
        this.companyNameInContactGUI = companyNameInContactGUI
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.companyNameInContact = jsonData === undefined ? "" : checkNull2String(jsonData.companyNameInContact)
        this.companyNameInContactGUI = jsonData === undefined ? "" : checkNull2String(jsonData.companyNameInContactGUI)
    }
}